const clearAllTokens = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("serverToken");
    sessionStorage.clear();
};

export {
    clearAllTokens
};